import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import { isAllowed } from "helper/acl";
import { isFrontPermissionVisible } from "helper/documentModules";
import { Checkbox, Loader } from "../../ui";

interface PermissionItem {
  slug?: string;
  front_permission?: string;
  name?: string | { value?: string };
}

interface ProfileDelegatePermissionsListProps extends WithTranslation {
  formData: { permissions: string[] };
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  permissions: PermissionItem[];
  permissionsLoaded: boolean;
  readonly?: boolean;
}

function getPermissionLabel(permission: PermissionItem): string {
  if (!permission) return "";

  if (typeof permission.name === "string") {
    return permission.name;
  }

  if (permission.name && typeof permission.name.value === "string") {
    return permission.name.value;
  }

  return permission.slug || permission.front_permission || "";
}

function ProfileDelegatePermissionsList({
  t,
  permissionsLoaded,
  permissions,
  formData,
  onChange,
  readonly,
}: ProfileDelegatePermissionsListProps) {
  if (!permissionsLoaded) {
    return (
      <div className="ComposedForm-fieldsetInner">
        <Loader />
      </div>
    );
  }

  if (permissions.length === 0) {
    return (
      <div className="ComposedForm-fieldsetInner">
        <p className="ListMessage">{t("common.label_no_data")}</p>
      </div>
    );
  }

  return (
    <div className="ComposedForm-fieldsetInner">
      {permissions.map((permission) => {
        if (
          isFrontPermissionVisible(permission.front_permission) &&
          isAllowed(permission.front_permission) &&
          isAllowed("webservice.delegate")
        ) {
          return (
            <div className="Permission ComposedForm-block" key={permission.slug}>
              <Checkbox
                value={permission.front_permission}
                id={permission.slug}
                inputClassName="Permission-checkbox"
                labelClassName="Permission-label"
                name="permissions[]"
                checked={formData.permissions.indexOf(permission.front_permission || "") !== -1}
                onChange={onChange}
                disabled={!!readonly}
                label={getPermissionLabel(permission)}
              />
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}

export default compose(withTranslation())(ProfileDelegatePermissionsList);
